import React from 'react';
// Import Global Components
import SectionOne from '../../../components/SectionOne';
import Text from '../../../components/Text';
// Import Translations
import { recoverEn } from '../../../i18n/recover';

export default () => (
  <SectionOne page="recover" label={recoverEn['recover-sectionOne-label']}>
    <Text
      page="recover"
      textFor="sectionOne-p1"
      text={recoverEn['recover-sectionOne-p1-text']}
    />
    <Text
      page="recover"
      textFor="sectionOne-p2"
      text={recoverEn['recover-sectionOne-p2-text']}
    />
  </SectionOne>
);
